$(document).on('lazyloaded', function (e) {
    if (window.matchMedia("(min-width: 992px)").matches) {
        let $this = $(e.target);
        if ($this.hasClass('header-background'))
            $('main[role="main"]').css({'margin-top': ($this.outerHeight(true) + 20) + 'px'});

        if ($this.hasClass('site-footer')) {
            $('main[role="main"]').css({'margin-bottom': ($this.outerHeight()) + 'px'});
        }
        $(window).scroll(function () {
            let $footer = $('footer.site-footer'),
                $header = $("header.site-header");
            $footer.css({'display': ($(window).scrollTop() >= ($header.height() + 100) ? 'block' : 'none')});
        });
    }
});

// menu functions
function setup_menu_control() {
    $(window).on("load resize", function () {
        // delay so page can adjust
        setTimeout(function () {
            // navbar on hover
            let $dropdown = $(".dropdown"),
                $dropdownToggle = $(".dropdown-toggle"),
                $dropdownMenu = $(".dropdown-menu"),
                showClass = "show";

            $dropdown.off();
            $dropdownToggle.off();
            $('.dropdown').off();

            $dropdownToggle.each(function () {
                new Hammer(this).off('tap doubletap');
            });

            if (window.matchMedia("(min-width: 992px)").matches) {
                $dropdownToggle.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = $(e.target).attr('href');
                })

                $dropdown.hover(
                    function () {
                        const $this = $(this);
                        $this.addClass(showClass);
                        $this.find($dropdownToggle).attr("aria-expanded", "true");
                        $this.find($dropdownMenu).addClass(showClass);
                    },
                    function () {
                        const $this = $(this);
                        $this.removeClass(showClass);
                        $this.find($dropdownToggle).attr("aria-expanded", "false");
                        $this.find($dropdownMenu).removeClass(showClass);
                    }
                );

                $('main[role="main"]').css({'margin-bottom': ($("footer#footer.site-footer").outerHeight()) + 'px'});

                if (!!$('.header-background').offset()) {
                    $('main[role="main"]').css({'margin-top': ($(".header-background").outerHeight(true) + 20) + 'px'});
                }
            } else {
                window.tapStarted = false;
                $dropdownToggle.each(function () {
                    // prevent links from navigating since we only want that on double tap
                    $(this).on('click', function (e) {
                        e.preventDefault();
                    })

                    // We create a manager object, which is the same as Hammer(), but without the preset recognizers.
                    let mc = new Hammer.Manager(this);

                    // Tap recognizer with minimal 2 taps
                    mc.add(new Hammer.Tap({event: 'doubletap', taps: 2}));
                    // Single tap recognizer
                    mc.add(new Hammer.Tap({event: 'singletap'}));

                    // we want to recognize this simulatenous, so a quadrupletap will be detected even while a tap has been recognized.
                    mc.get('doubletap').recognizeWith('singletap');
                    // we only want to trigger a tap, when we don't have detected a doubletap
                    mc.get('singletap').requireFailure('doubletap');

                    mc.on("singletap", function (e) {
                        const $this = $(e.target);

                        $dropdownToggle.not($this).removeClass('show').attr('aria-expanded', "false");
                        $this.parent().removeClass('active')
                        $dropdownMenu.not($this.parent().find($dropdownMenu)).removeClass('show');

                        $this.toggleClass(showClass);
                        $this.attr("aria-expanded", $this.attr("aria-expanded") === 'true' ? "false" : "true");
                        $this.parent().find('.dropdown-menu').toggleClass(showClass);
                    });

                    mc.on("doubletap", function (e) {
                        console.debug(e, 'dtap');
                        const $this = $(e.target);
                        window.location.href = $this.attr('href');
                    });
                })

                $('main[role="main"]').css({'margin-bottom': 'unset'});

                if (!!$('.header-background').offset()) {
                    $('main[role="main"]').css({'margin-top': '16px'});
                }
            }
        }, 250);
    });

    $('.search-submit').replaceWith('<button class="search-submit" type="submit"><i class="fas fa-search"></i></button>')
}

// setup scroll actions
function header_style() {
    let $body = $("body"),
        $header = $('.wrapper > header'),
        $headerSmall = $("header .header-small"),
        $navbar = $("nav.navbar");

    let header_style = ($body.hasClass('header-transparent') ? 'transparent' : 'translucent');

    if (window.scrollX > 0)
        window.scroll(0, window.scrollY);

    if ($header.hasClass('menu-opened')) {
        $header.removeClass('navbar-light').addClass('navbar-dark');
        return;
    }

    // fix if missing class
    $navbar.find('img.custom-logo').parent().addClass('custom-logo');

    if ($(window).scrollTop() >= $headerSmall.height()) {
        $body.addClass("is-scrolled");
        if (header_style === "transparent") {
            $header.removeClass('navbar-light').addClass('navbar-dark');
        }

    } else {
        $body.removeClass("is-scrolled");
        if (header_style === "transparent") {
            $header.removeClass('navbar-dark').addClass('navbar-light');
        }

    }

}

// setup header spacing
function header_spacing(spacing = null) {
    let $header = $('.wrapper > header'),
        $headerBackground = $('.header-background');
    let headerHeight = 0;

    if (spacing === null)
        $header.children().each(function () {
            headerHeight += $(this).outerHeight(true);
        });
    else
        headerHeight = spacing;

    $headerBackground.css('margin-top', Math.abs(headerHeight) * -1);
    if ($headerBackground.data('initial-height') === undefined)
        $headerBackground.data('initial-height', Math.abs(headerHeight) * -1);

    // console.debug('done header_spacing()');
}

$(document).ready(function () {
    let $body = $("body"),
        $header = $('.wrapper > header'),
        $headerSmall = $("header .header-small"),
        $headerWrapper = $('header'),
        $navbar = $("nav.navbar");

    // disable video right click
    $body.on('contextmenu', 'video', function () {
        return false;
    });

    // disabled page-loader on meta anchors
    $body.on('click', 'a', function (e) {
        let restricted = ['tel', 'mailto', '#'],
            disable = restricted.filter(href => e.target.href.indexOf(href) > -1).length > 0;

        if (!disable && e.target.attr('target') !== "_blank") $('body').removeClass('loaded');
        window.showLoader = !disable;
    });

    if ($body.hasClass('header-js-disabled') === false) {
        // give mobile menu a background to fix moving background image
        $navbar.find('.navbar-collapse').on('show.bs.collapse hide.bs.collapse', function (e) {
            let header_type = ($body.hasClass('header-transparent') && !$header.hasClass('has-background') ? 'transparent' : 'translucent');

            if ($headerWrapper.hasClass('menu-opened')) {
                $body.css('overflow-y', 'auto');
                $headerSmall.animate({opacity: 1}, 475);
            } else {
                $body.css('overflow-y', 'hidden');
                $headerSmall.animate({opacity: 0}, 50);
            }

            $navbar.animate({background_color: ($headerWrapper.hasClass('menu-opened') ? 'transparent' : 'black')}, 350);
            $headerWrapper.toggleClass('menu-opened');
            header_style();
        });


        $(window).scroll(header_style);
        header_style();

        // shove the main section down if we have a header background
        if ($header.hasClass('has-background')) {
            // temporary
            $navbar.find('img.custom-logo-invert').removeClass('custom-logo-invert');
        }

        // setup menu controls
        setup_menu_control();
    }

    joelle_i18n.options.load_path += "/calculators/";
    var mortLoaded = false;
    var landLoaded = false;
    var chmcLoaded = false;

    $('a[href="#mort"]').on('shown.bs.tab', function (e) {
        if (!mortLoaded)
            $("#mort").load(joelle_i18n.options.load_path + "/mortgage.php?lang=" + joelle_i18n.lang, function () {
                mortLoaded = true;
            });
    });

    $('a[href="#land"]').on('shown.bs.tab', function (e) {
        if (!landLoaded)
            $("#land").load(joelle_i18n.options.load_path + "/tax.php?lang=" + joelle_i18n.lang, function () {
                landLoaded = true;
            });
    });

    $('a[href="#chmc"]').on('shown.bs.tab', function (e) {
        if (!chmcLoaded)
            $("#chmc").load(joelle_i18n.options.load_path + "/chmc.php?lang=" + joelle_i18n.lang, function () {
                chmcLoaded = true;
            });
    });

    if (!mortLoaded)
        $('a[href="#mort"]').trigger('click');

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazyload-video"));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazyload-video");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});

window.addEventListener('focus', function () {
    var videos = [].slice.call(document.querySelectorAll("video"));
    videos.forEach(function (video) {
        if (video.state === false) // was not paused
            video.play();
    })
});

window.addEventListener('blur', function () {
    var videos = [].slice.call(document.querySelectorAll("video"));
    videos.forEach(function (video) {
        video.state = video.paused;
        video.pause();
    })
});
